import React, { useState ,useEffect, useRef} from 'react'
import './InputRange.css';

  export  const InputRange = ({ min,max,step,className, onChange, title, disabled, values, handleUpperChange, handleLowerChange, inputFrom, inputTo, sliderRef }) => {
   /*
    const [inputFrom,setInputFrom ] = useState(values.minCals);
    const [inputTo,setInputTo ] = useState(values.maxCals);
    const sliderRef = useRef(null);
    console.log(inputFrom, inputTo)
 

    useEffect(() => {
      console.log('click')
        if (sliderRef.current===null) return;
        if (inputFrom>inputTo){
            sliderRef.current.style.right = `${100-(inputFrom-min)/(max-min)*100}%`;
            sliderRef.current.style.left = `${(inputTo-min)/(max-min)*100}%`;
        }else{
            sliderRef.current.style.right = `${100-(inputTo-min)/(max-min)*100}%`;
            sliderRef.current.style.left = `${(inputFrom-min)/(max-min)*100}%`;
        }

        if (onChange){
            onChange({inputFrom,inputTo});
        } 
    }, [inputFrom, inputTo])
    

    const handleLowerChange = (e) => {
      const value = parseFloat(e.target.value);
      // Проверка, чтобы правый ползунок был не менее чем на 100 больше
      if (value + step <= inputTo) {
          setInputFrom(value);
      }
  };

  const handleUpperChange = (e) => {
    const value = parseFloat(e.target.value);
    // Проверка, чтобы левый ползунок был не больше чем на 100 меньше
    if (value - step >= inputFrom) {
        setInputTo(value);
    }
};
*/
  return (
    <div className={`${className}`}>
      <div className="range-slider">
        <span className="range-selected" ref={sliderRef}></span>
      </div>
      <div className="range-input">
      <label className='range-input_title font20Norm colorGrey'>{title}</label>
        <input type="range" 
        onChange={handleLowerChange}
         // onChange={(e)=>setInputFrom(parseFloat(e.target.value))}
          className='range__input'
          min={min}
          max={max}
          step={step}
          value={inputFrom}
          disabled={disabled}/>
        <input type="range"
         onChange={handleUpperChange}
          //onChange={(e)=>setInputTo(parseFloat(e.target.value))}
          id="tailmetr"
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          value={inputTo}/>
          <span className='range__input_min font14Norm'>{inputFrom}</span>
           <span className='range__input_max font14Norm'>{inputTo}</span>
       
        </div>
    </div>
  )
      };